module.exports = __webpack_public_path__ + "files/9694fbd26939f9380d9c1de16c79166f.png";